import { message } from "antd";
import { client } from "../../../actions";
import { authHeader } from "../../../helpers/auth-header";

const deleteTagFromMeter = async (MeterId, TagId) => {
	try {
		await client.delete("/Meter/meter_tags", {
      data: {
        MeterId,
				TagId,
      },
			headers: authHeader(),
		});
	} catch (error) {
		console.error(error);
		message.error("Не получилось удалить тег счетчика");
	}
};

export default deleteTagFromMeter;
